import web from '../web';

const appUrl =  process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

export {appUrl}
/*
const web = axios.create({
    baseURL : 'http://141.95.54.188:8080/gschoolarys',
    headers : {
        "Content-Type": "application/json"
    }
})*/

class LoginService{
    login(data){
       return web.post("/api/auth/authentification", data)
    }

    logout(token) {
        return web.post("/api/auth/logout",{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new LoginService